import * as tslib_1 from "tslib";
import React from 'react';
import ElementQueries from '../../../ElementQueries';
import s from './GallectionGrid.scss';
var GallectionGrid = /** @class */ (function (_super) {
    tslib_1.__extends(GallectionGrid, _super);
    function GallectionGrid() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderGallection = function (gallection, index) {
            var gallectionRenderer = _this.props.gallectionRenderer;
            return (React.createElement("div", { key: index, className: s['folder-card-wrapper'] }, gallectionRenderer(gallection, index)));
        };
        return _this;
    }
    GallectionGrid.prototype.render = function () {
        var gallections = this.props.gallections;
        if (!gallections) {
            return null;
        }
        return (React.createElement(ElementQueries, { widthBreakpoints: [450, 900], className: s['grid'] }, gallections.map(this.renderGallection)));
    };
    return GallectionGrid;
}(React.Component));
export { GallectionGrid };
export default GallectionGrid;
//# sourceMappingURL=GallectionGrid.js.map